export const toggleClasses = (element, classes) => {
	classes.forEach((cls) => element?.classList.toggle(cls));
};
